import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './DashboardUserMenu.css';

export default function DashboardUserMenu() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <Dropdown align="end" className="dashboard-user-menu ms-auto">
      <Dropdown.Toggle id="dashboard-user-menu" variant="light" aria-label="Open user menu" className="dashboard-user-menu__toggle">
        <i className="bi bi-person-circle" aria-hidden="true" />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Header>
          <span className="dashboard-user-menu__name">{currentUser?.name || 'Your account'}</span>
          <span className="dashboard-user-menu__role">{currentUser?.role}</span>
        </Dropdown.Header>
        <Dropdown.Divider />
        <Dropdown.Item as="button" className="dashboard-user-menu__logout" onClick={() => { logout(); navigate('/login', { replace: true }); }}>
          <i className="bi bi-box-arrow-right me-2" aria-hidden="true" />Log out
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
